import React, { Component } from 'react'
import { connect } from 'react-redux'

import removeActiveRestaurants from '../../actions/removeActiveRestaurants'

import yn from 'yn'
import moment from 'moment/moment'

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS)) {
	require('../../styles/css/components/restaurants/bk-flow-restaurants-payment-cards.css')
}

class BkFlowRestaurantsPaymentCards extends Component  {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const {
			configData,
			activeRestaurantsData,
			handleRemoveActiveRestaurant,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]
		let activeRestaurantCards = []

		for (const restaurantKey in activeRestaurantsData) {
			const currentRestaurantCard = activeRestaurantsData[restaurantKey]

			activeRestaurantCards.push(
				<div
					key={ currentRestaurantCard.venueId }
					className="bk-flow-restaurants__payment-card"
				>
					<button
						className="bk-flow-restaurants__payment-card-remove"
						onClick={ () => handleRemoveActiveRestaurant(currentRestaurantCard.venueId) }
					>
						{ hotelLabels && hotelLabels.remove ? hotelLabels.remove : 'Remove' }
						<i className="material-icons">close</i>
					</button>

					{ currentRestaurantCard.name &&
						<p className="bk-flow-restaurants__card-title">{currentRestaurantCard.name}</p>
					}

					{ currentRestaurantCard.date &&
						<p className="u-remove-margin">
							<span className="u-font-bold">{ hotelLabels && hotelLabels.date ? hotelLabels.date : 'Date' }:</span>
							&nbsp;
							{ moment(currentRestaurantCard.date, 'YYYY-MM-DD').format('ddd, MMM Qo, YYYY') }
						</p>
					}

					{ currentRestaurantCard.date &&
						<p className="u-remove-margin">
							<span className="u-font-bold">{ hotelLabels && hotelLabels.time ? hotelLabels.time : 'Time' }:</span>
							&nbsp;
							{ currentRestaurantCard.time }
						</p>
					}

					{ currentRestaurantCard.party &&
						<p className="u-remove-margin">
							<span className="u-font-bold">{ hotelLabels && hotelLabels.guests ? hotelLabels.guests : 'Guests' }:</span>
							&nbsp;
							{ currentRestaurantCard.party }
						</p>
					}
				</div>
			)
		}

		return (
			<div
				className="bk-flow-restaurants__payment-cards"
			>
				<h4>Reservations</h4>
				{ activeRestaurantCards }
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		activeRestaurantsData: state.activeRestaurantsData
	}
}

const mapDispatchToProps = dispatch => ({
	handleRemoveActiveRestaurant(activeVenueId) {
		return dispatch(removeActiveRestaurants(activeVenueId))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRestaurantsPaymentCards)



// WEBPACK FOOTER //
// ./src/components/restaurants/BkFlowRestaurantsPaymentCards.js